export const PROTECTED_TAG_IDS = new Set(['internal-tester', 'exclude-from-stats']);
